module.exports = __webpack_public_path__ + "img/simon-fraser-university.5a6b5778.png";